/**
 * The small teal "ACTIVE" badge shown next to the live revision.
 *
 * Shared by the revision selectors (builder header + insights scope) and the
 * insights group-header so the badge styling lives in exactly one place.
 *
 * The styling is kept as an inline-style constant rather than a SCSS class on
 * purpose: antd's own `.ant-tag` rules would otherwise win the cascade for
 * color/border/font-size and drift the badge. `marginLeft` is the only
 * context-dependent value, so it's a prop.
 */

import React from 'react'
import { Tag } from 'antd'

const ACTIVE_TAG_STYLE: React.CSSProperties = {
    fontSize: 10,
    fontWeight: 700,
    letterSpacing: '0.04em',
    textTransform: 'uppercase',
    color: 'var(--color-secondary-100)',
    border: '1px solid #b8e4dd',
    borderRadius: 2,
    padding: '0 5px',
    lineHeight: '14px',
}

export interface RevisionActiveTagProps {
    /** Left margin to match the surrounding layout (varies by call site). */
    marginLeft?: number
    /** Badge text. Defaults to "Active" (rendered uppercase via text-transform). */
    label?: string
}

export const RevisionActiveTag: React.FC<RevisionActiveTagProps> = ({ marginLeft, label = 'Active' }) => (
    <Tag
        className="revision-active-tag"
        style={marginLeft != null ? { ...ACTIVE_TAG_STYLE, marginLeft } : ACTIVE_TAG_STYLE}
    >
        {label}
    </Tag>
)
